import React, { Component } from "react";
import PropTypes from "prop-types";
import {debounce} from 'lodash';
import { connect } from "react-redux";
import defaultTheme from "../../theme/default";
import { MessagingLayer } from "../../context/messaging-layer";
import { ToastNotifications } from "../../context/toast-notifications";
import { RootContext } from "../../context/root-ref";
import { constants } from "../../resource/constants";
import { addToast, removeToast } from "../../redux/actions";
import {} from "../../redux/thunks";
import ProviderSearchForm from "./provider-search-form";
import ProviderItem from "./provider-item";
import { createProvidersFetcher } from "../../api/providers";
import ProviderDetails from "./provider-details";
import Toasts from "../toast-notification";
import {
  PROVIDER_TOAST_ID,
  providerMessages,
  zipRegex,
  providerSpecialties,
} from "../../resource/find-providers";
import { extractSearchData } from "../../utils/extract-search-data";
import HeartIcon from "../../styles/default/assets/icons/heart.svg";
import EmptyHeartIcon from "../../styles/default/assets/icons/heart-empty.svg";
import showFilterIcon from "../../styles/default/assets/icons/controls-setup-preferences.svg";

const ProviderMarker = ({
  provider,
  active,
  selected,
  onMouseEnter,
  onMouseLeave,
  onClick,
}) => {
  const {
    profile: { firstName, lastName },
    practices,
  } = provider;
  const {
    distance,
    visitAddress: { street, city, state, zip },
  } = practices[0];
  return (
    <div>
      <div
        className={`g-map-marker-web-sdk ${active || selected ? "active" : ""}`}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={onClick}
      />
      {selected && (
        <div className="g-map-tooltip-web-sdk">
          <div className="g-map-tooltip-header-web-sdk">{`${firstName} ${lastName}`}</div>
          <div className="websdk-flex websdk-justify-between g-map-tooltip-section-web-sdk">
            <div>{street}</div>
            <div>{distance.toFixed(2)} mi</div>
          </div>
          <div className="g-map-tooltip-section-web-sdk">
            {city}, {state} {zip}
          </div>
        </div>
      )}
    </div>
  );
};

class FindProviders extends Component {
  hoverOnProviderItem = debounce(provider => {
    this.setState({ selectedListProvider: provider.id })
    this.mapCenter = [provider.practices[0].lat, provider.practices[0].lon];
  }, 250);

  constructor(props) {
    super(props);
    this.rootRef = React.createRef();
    const specialty = providerSpecialties.find(
      (x) =>
        x.value === this.props.extendedConfiguration.findProviders.specialty
    );
    this.state = {
      inputsValues: {
        zip:     this.props.extendedConfiguration.findProviders.zip,
        radius:  10,
        gender:  "All",
        specialty,
        version: 2
      },
      providersData:        [],
      showSearchResults:    true,
      loadingInProgress:    false,
      favoriteProviders:    [],
      isFiltersCollapsed:   true,
      selectedListProvider: "",
    };
    this.markers = [];
    this.selectedProvider = null;
    this.activeProvider = null;
    this.extendedConfiguration = this.props.extendedConfiguration.findProviders;
    this.mapCenter = [0, 0];

    this.formFetcher = createProvidersFetcher();
  }

  componentDidMount() {
    if (this.extendedConfiguration.addToFavorites) {
      this.addToFavorites = this.extendedConfiguration.addToFavorites;
    }

    if (this.extendedConfiguration.favoriteProviders) {
      this.setState({
        favoriteProviders: this.extendedConfiguration.favoriteProviders,
      });
    }
    let name = [];
    let value = [];

    if (this.extendedConfiguration.specialty) {
      const specialty = providerSpecialties.find(
        x => {
          if(x.value === this.extendedConfiguration.specialty){
            return x.value === this.extendedConfiguration.specialty
          }
          return x.value === 'general'
        }
      );
      name.push("specialty");
      value.push(specialty);
      this.setState({
        inputsValues: {
          specialty: { label: specialty.label, value: specialty.value }
        }
      });
    }

    if (this.extendedConfiguration.zipCode) {
      name.push("zip");
      value.push(this.extendedConfiguration.zipCode);
    }

    if (name.length) {
      this.onFieldChange(value, name);
    }
  }

  componentWillUnmount() {
    this.markers.forEach((m) => this.maps.event.clearInstanceListeners(m));
    const abortController = window[constants.abortControllerKey];
    if (abortController) {
      abortController.abort();
    }
  }

  onInputsChange = ({ currentTarget: { value } }, name) => {
    this.onFieldChange(value, name);
  };

  onRadiusChange = (value) => {
    this.onFieldChange(value, "radius");
  };

  onZipChange = (value) => {
    this.onFieldChange(value, "zip");
  };

  onSpecialtyChange = (value) => {
    if (!value) return;
    const specialty = providerSpecialties.find((x) => x.value === value);
    this.onFieldChange(specialty, "specialty");
  };

  onGenderChange = (value) => {
    this.onFieldChange(value, "gender");
  };

  onFieldChange = (value, name) => {
    let inputsChanged = false;

    if(value === 'clear'){
      inputsChanged = true;
    }

    const inputsValues = { ...this.state.inputsValues };

    if (typeof value === "object" && Array.isArray(value)) {
      value.forEach((v, i) => {
        if (inputsValues[name[i]] !== v) {
          inputsValues[name[i]] = v;
          inputsChanged = true;
        }
      });
    } else if (inputsValues[name] !== value) {
      inputsValues[name] = value;
      inputsChanged = true;
    }
    if (inputsChanged && inputsValues.zip) {
      this.props.removeToast(PROVIDER_TOAST_ID);
      this.setState(
        {
          inputsValues,
        },
        () => {
          if (zipRegex.test(inputsValues.zip)) {
            this.setState({ loadingInProgress: true }, () => {
              const searchParams = this.extractSearchParams(
                this.state.inputsValues
              );
              this.formFetcher(searchParams).then((res) => {
                if (res) {
                  res.json().then((res) => {
                    if (res?.data?.doctors) {
                      let providersData = [...res.data.doctors];
                      this.setState({
                        providersData,
                        loadingInProgress: false,
                      });
                      if (providersData.length == 0) {
                        this.showToast();
                      }
                    } else {
                      if (!res || !res.data) {
                        this.setState({
                          loadingInProgress: false,
                        });
                        this.showToast("FETCHING_ERROR");
                      } else {
                        this.setState({
                          providersData:     [],
                          loadingInProgress: false,
                        });
                        this.showToast();
                      }
                    }
                  });
                }
              });
            });
          }
        }
      );
    } else {
      this.setState({ inputsValues }, () => {
        this.showToast("ZIP_REQUIRED");
      });
    }
  };

  onClearFilters = () => {
    this.setState({
      inputsValues: {
        zip:       this.extendedConfiguration.zipCode,
        radius:    10,
        gender:    "All",
        specialty: { label: "Primary Care Physician", value: "general" },
        version:   2
      },
      providersData: []
    },  () =>{
      this.onFieldChange('clear', 'clear');
    });
  };

  extractSearchParams = (data) => {
    let payload = data;
    if (data?.specialty?.value) {
      payload = { ...data, specialty: data.specialty.value };
    }

    return `?${extractSearchData(payload)}`;
  };

  drawProviders = () => {
    const { theme = {} } = this.props;
    const components = { ...defaultTheme, ...theme };

    let providers = [...this.state.providersData];
    return providers.map((provider, i) => {
      return (
        <ProviderItem
          key={i}
          providerData={provider}
          components={components}
          onProviderSelect={(event) =>
            this.switchSearchProviderDetails(event, provider)
          }
          addFavoriteIcon={this.addFavoriteIcon}
          favoriteProviders={this.state.favoriteProviders}
          onMouseEnter={() => this.hoverOnProviderItem(provider)}
          onMouseLeave={() => this.setState({ selectedListProvider: "" })}
          active={provider.id === this.activeProvider}
          selected={provider.id === this.state.selectedListProvider}
        />
      );
    });
  };

  renderProvidersOnMap = ({ map, maps: { LatLng, LatLngBounds, Marker } }) => {
    const bounds = new LatLngBounds();
    this.state.providersData.forEach((provider) => {
      const lat = parseFloat(provider.practices[0].lat);
      const lng = parseFloat(provider.practices[0].lon);
      bounds.extend(new LatLng(lat, lng));
    });
    map.fitBounds(bounds);
  };

  handleMarkerClick = (event, provider) => {
    event.stopPropagation();
    this.setState({
      selectedListProvider:
        this.state.selectedListProvider === provider.id ? "" : provider.id,
    });
    this.mapCenter = [provider.practices[0].lat, provider.practices[0].lon];
  };

  switchSearchProviderDetails = (event = null, provider) => {
    if (event) {
      event.stopPropagation();
    }

    if (provider) {
      this.selectedProvider = provider;
    } else {
      this.selectedProvider = null;
    }

    this.setState({ showSearchResults: !this.state.showSearchResults });
  };

  showToast = (messageType = "NO_PROVIDERS") => {
    this.props.addToast({
      id:      PROVIDER_TOAST_ID,
      message: providerMessages[messageType],
    });
  };

  addFavoriteIcon = (isFavorite, providerData, setFavorite) => {
    const { theme = {} } = this.props;
    const components = { ...defaultTheme, ...theme };
    return this.addToFavorites ? <components.Icon showIcon src={isFavorite ? HeartIcon : EmptyHeartIcon} onClick={() => this.toggleFavorite(isFavorite, providerData, setFavorite)} /> : null
  };

  toggleFavorite = (isFavorite, providerData, setFavorite) => {
    if (!isFavorite) {
      this.addToFavorites({
        favorite: true,
        meta:     providerData,
      });
      this.state.favoriteProviders.push({ data: { id: providerData.id } });
    } else {
      this.addToFavorites({
        favorite: false,
        meta:     providerData,
      });
      const index = this.state.favoriteProviders.findIndex(
        (item) => item.data.id === providerData.id
      );
      index > -1 && this.state.favoriteProviders.splice(index, 1);
    }
    setFavorite(!isFavorite);
  };

  setFiltersCollapsed = (state) => {
    this.setState({ isFiltersCollapsed: state });
  };

  render() {
    const { toasts, removeToast, screenParams, theme = {} } = this.props;

    const components = { ...defaultTheme, ...theme };

    return (
      <MessagingLayer
        components={components}
        globalDialogConfig={screenParams.dialogConfig}
      >
        <ToastNotifications components={components}>
          <RootContext.Provider value={this.rootRef}>
            <Toasts
              toasts={toasts}
              onClose={(toastId) => removeToast(toastId)}
              components={components}
            />
            <components.Title
              title={`${
                this.state.showSearchResults
                  ? "Find providers"
                  : "Provider details"
              }`}
            />
            {this.state.showSearchResults ? (
              <div className="find-providers-web-sdk">
                <div
                  className={`header-search-wrapper-web-sdk${
                    !this.state.isFiltersCollapsed ? " expanded" : ""
                  }`}
                >
                  <div className="expando-provider-header-web-sdk">
                    <span
                      className="clickable"
                      onClick={() =>
                        this.setFiltersCollapsed(!this.state.isFiltersCollapsed)
                      }
                    >
                      Find and filter
                    </span>
                    {!this.state.isFiltersCollapsed ? (
                      <span
                        className="clickable collapse-web-sdk"
                        onClick={() => this.setFiltersCollapsed(true)}
                      >
                        Collapse
                      </span>
                    ) : (
                      <components.Icon
                        showIcon={true}
                        src={showFilterIcon}
                        onClick={() => this.setFiltersCollapsed(false)}
                      />
                    )}
                  </div>
                  <form id="containerForm" ref={this.rootRef}>
                    <ProviderSearchForm
                      isFiltersCollapsed={this.state.isFiltersCollapsed}
                      components={components}
                      onInputsChange={this.onInputsChange}
                      onRadiusChange={this.onRadiusChange}
                      onSpecialtyChange={this.onSpecialtyChange}
                      onGenderChange={this.onGenderChange}
                      data={this.state.inputsValues}
                      onClearFilters={this.onClearFilters}
                    />
                  </form>
                </div>

                {!this.state.loadingInProgress ? (
                  this.state.providersData.length ? (
                    <div className="providers-search-results-web-sdk">
                      <div className="providers-list-web-sdk">
                        {this.drawProviders()}
                      </div>
                      <div
                        className={`providers-map-web-sdk ${
                          this.state.isFiltersCollapsed ? "" : "collapsed"
                        }`}
                      >
                        <components.GMap
                          renderLocations={this.renderProvidersOnMap}
                          center={this.mapCenter}
                        >
                          {this.state.providersData.map((provider) => {
                            return (
                              <ProviderMarker
                                provider={provider}
                                active={provider.id === this.activeProvider}
                                selected={
                                  provider.id ===
                                  this.state.selectedListProvider
                                }
                                onMouseEnter={() =>
                                  (this.activeProvider = provider.id)
                                }
                                onMouseLeave={() => (this.activeProvider = "")}
                                onClick={(e) =>
                                  this.handleMarkerClick(e, provider)
                                }
                                lat={parseFloat(provider.practices[0].lat)}
                                lng={parseFloat(provider.practices[0].lon)}
                              />
                            );
                          })}
                        </components.GMap>
                      </div>
                    </div>
                  ) : null
                ) : (
                  <components.Loader />
                )}
              </div>
            ) : (
              <ProviderDetails
                onBackButton={this.switchSearchProviderDetails}
                components={components}
                providerData={this.selectedProvider}
                addFavoriteIcon={this.addFavoriteIcon}
                favoriteProviders={this.state.favoriteProviders}
              />
            )}
          </RootContext.Provider>
        </ToastNotifications>
      </MessagingLayer>
    );
  }
}

FindProviders.propTypes = {
  addToast:            PropTypes.func.isRequired,
  removeToast:         PropTypes.func.isRequired,
  fieldConfigurations: PropTypes.object,
  toasts:              PropTypes.array,
  theme:               PropTypes.object,
};

export default connect(
  ({ tdFlow }) => ({
    toasts:       tdFlow.toasts,
    screenParams: tdFlow.screenParams,
  }),
  {
    addToast,
    removeToast,
  }
)(FindProviders);
